// use-user-preferences.ts — Current-user suite, subscription.

'use client';

import { useMemo } from 'react';

import { useCookieValue } from '@/contexts/cookies';
import {
  USER_PREFERENCES_COOKIE_SUB_PATH,
  USER_PREFERENCES_DEFAULTS,
} from './user-preferences-model';
import { sanitizeUserPreferences } from './user-preferences-normalizers';
import { useUserPreferenceActions } from './use-user-preference-actions';
import type {
  UserPreferenceActions,
  UserPreferences,
} from './user-preferences-model';

export {
  SessionContentVersionRenderMode,
  SESSION_FOLD_PREFERENCES_DEFAULTS,
  USER_PREFERENCES_DEFAULTS,
} from './user-preferences-model';
export type {
  SessionFoldPreferences,
  UserPreferences,
} from './user-preferences-model';

type UseUserPreferencesResult = {
  prefs: UserPreferences;
} & UserPreferenceActions;

export function useUserPreferences(): UseUserPreferencesResult {
  const {
    value: cookieValue,
    setValue: setCookieValue,
  } = useCookieValue<UserPreferences>({
    subPath: USER_PREFERENCES_COOKIE_SUB_PATH,
    defaultValue: USER_PREFERENCES_DEFAULTS,
  });

  const prefs = useMemo(
    () => sanitizeUserPreferences(cookieValue),
    [cookieValue],
  );
  const actions = useUserPreferenceActions(setCookieValue);

  return {
    prefs,
    ...actions,
  };
}
